import Ajaxinate from "ajaxinate";
import { _addEventListener } from "../utilities/Helpers/eventHelper";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { hide } from "../utilities/Helpers/helpers";

LUC.jsBlog = {
    init: ($section) => {
        LUC.jsBlog.loadMoreArticles();
        LUC.jsBlog.initializeSliders();
        LUC.jsBlog.setupCopyLinkAndCloseMessageListeners();
    },

    initializeSliders: function () {
        const relatedArticlesSections = document.querySelectorAll('[data-section-type="related-articles"]');
        const blogArticlesSections = document.querySelectorAll('[data-section-type="blog-articles"]');

        if (relatedArticlesSections.length > 0) {
            relatedArticlesSections.forEach((section) => {
                LUC.jsBlog.relatedArticlesSlider(section);
            });
        }

        if (blogArticlesSections.length > 0) {
            blogArticlesSections.forEach((section) => {
                LUC.jsBlog.homeArticlesSlider(section);
            });
        }
    },

    relatedArticlesSlider: function (section) {
        const sliders = section.querySelectorAll("[data-slider]");
        sliders.forEach((slider) => {
            const swiperInstance = new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 1.2,
                spaceBetween: 2,
                centeredSlides: false,
                loop: true,
                autoplay: false,
                allowTouchMove: true,
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 2,
                    },
                    2048: {
                        slidesPerView: 4,
                        spaceBetween: 2,
                    },
                },
                navigation: {
                    nextEl: "[data-btn-next]",
                    prevEl: "[data-btn-prev]",
                },
            });
        });
    },

    homeArticlesSlider: function (section) {
        const swiperHomeBlogSlider = document.getElementById("swiper-home-blog");
        if (swiperHomeBlogSlider) {
            const swiperInstance = new Swiper(swiperHomeBlogSlider, {
                modules: [Navigation, Pagination],
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                allowTouchMove: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: "[data-btn-next]",
                    prevEl: "[data-btn-prev]",
                },
            });
        }
    },

    loadMoreArticles: function () {
        const container = document.querySelector("#article-grid");
        new Ajaxinate({
            container: "#article-grid",
            pagination: "[data-pagination-next-el]",
            method: "click",
            callback: (data) => {
                const articlesLength = container.querySelectorAll("article").length;
                const paginationCountLabel = document.querySelector("[data-pagination-count]");
                const progressbarEl = document.querySelector("[data-pagination-progress-bar]");
                const paginationBtn = document.querySelector("[data-pagination-next-el]");
                const paginationMoreItems = document.querySelector("[data-pagination-more-items]");
                const visibleArticlesSpan = document.querySelector("[data-visible-articles]");

                if (paginationCountLabel) {
                    paginationCountLabel.innerText = articlesLength;
                }

                if (visibleArticlesSpan) {
                    visibleArticlesSpan.innerText = articlesLength;
                }

                const paginationCountAllValue = parseInt(paginationCountLabel.dataset.paginationCountAll);

                if (progressbarEl) {
                    const progress_percent = (articlesLength * 100) / paginationCountAllValue;
                    progressbarEl.style.width = `${progress_percent}%`;
                }

                if (articlesLength >= paginationCountAllValue) {
                    hide(paginationBtn);
                } else {
                    const lastElements = paginationCountAllValue - articlesLength;
                    if (lastElements <= 16) {
                        if (paginationMoreItems) {
                            paginationMoreItems.innerText = lastElements;
                            paginationBtn.setAttribute("data-pagination-last-step", "");
                            LUC.jsBlog.paginateLastStepHandler();
                        }
                    }
                }
                //Helper to set Focus on first element after load new content
                setTimeout(() => {
                    const firstNewArticle = data.querySelector("#article-grid > article");
                    if (firstNewArticle) {
                        const handle = firstNewArticle.dataset.handle;
                        const selector = `[data-handle="${handle}"] a`;
                        const firstLink = document.querySelector(selector);
                        if (firstLink) {
                            firstLink.focus();
                        }
                    }
                }, 500);
            },
        });
    },
    paginateLastStepHandler: function () {
        const lastStepBtn = document.querySelector("[data-pagination-last-step]");
        _addEventListener(lastStepBtn, "click", () => {
            const progressbarEl = document.querySelector("[data-pagination-progress-bar]");
            const paginationCountLabel = document.querySelector("[data-pagination-count]");

            if (progressbarEl) {
                progressbarEl.style.width = "100%";
            }

            if (paginationCountLabel) {
                paginationCountLabel.innerText = paginationCountLabel.dataset.paginationCountAll;
            }
        });
    },
    copyLink: function () {
        const url = window.location.href;
        navigator.clipboard
            .writeText(url)
            .then(() => {
                console.log("Text copied to clipboard");
                const successMessage = document.querySelector("[data-success-tooltip]");
                successMessage.classList.add("tw-flex");
                successMessage.classList.remove("tw-hidden");
                setTimeout(() => {
                    successMessage.classList.remove("tw-flex");
                    successMessage.classList.add("tw-hidden");
                }, 15000);
            })
            .catch((err) => {
                console.error("Failed to copy text: ", err);
            });
    },
    closeMessage: function () {
        const successMessage = document.querySelector("[data-success-tooltip]");
        successMessage.classList.remove("tw-flex");
        successMessage.classList.add("tw-hidden");
    },
    setupCopyLinkAndCloseMessageListeners: function () {
        const copyLinkBtn = document.getElementById("copyLink");
        const closeMessageBtn = document.querySelector("[data-close-tooltip]");

        if (copyLinkBtn) {
            _addEventListener(copyLinkBtn, "click", LUC.jsBlog.copyLink);
        }

        if (closeMessageBtn) {
            _addEventListener(closeMessageBtn, "click", LUC.jsBlog.closeMessage);
        }
    },
};
